var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature5173Caa5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 105,
    viewBox: "0 0 173 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.0648 34.315V34.4368L53.9583 34.3718L50.302 32.1545L54.0648 34.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.0649 34.3151L60.8446 30.441L54.0649 34.3151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.8445 30.4408L54.0648 34.315L50.302 32.1545L57.0817 28.2723L60.8445 30.4408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.36078 68.1511V68.1674C1.15583 67.9806 0.967283 67.7775 0.811523 67.5826V67.5663C0.967283 67.7694 1.15583 67.9643 1.36078 68.1511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.51648 68.297C1.46729 68.2564 1.40991 68.2158 1.36072 68.167V68.1508C1.40991 68.1995 1.45909 68.2483 1.51648 68.297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.51648 65.893C1.55747 65.9255 1.60666 65.958 1.64765 65.9905C1.59846 65.958 1.54927 65.9255 1.51648 65.893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2.48406 68.9956C2.41848 68.955 2.36929 68.9144 2.30371 68.8738C2.36929 68.9144 2.42668 68.955 2.48406 68.9956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.68884 68.4352C1.77902 68.5083 1.87739 68.5814 1.97577 68.6545C1.87739 68.5896 1.78722 68.5165 1.68884 68.4352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2.27871 66.4536C2.18853 66.3967 2.09016 66.3399 2.00818 66.283C2.08196 66.3318 2.16394 66.3805 2.24592 66.4373C2.25412 66.4373 2.27051 66.4455 2.27871 66.4536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2.59853 69.0607C2.55755 69.0363 2.52475 69.0201 2.48376 68.9957V68.9876C2.52475 69.012 2.55755 69.0363 2.59853 69.0607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M170.36 46.5547C170.582 46.4328 170.787 46.3029 170.975 46.1648C171.041 46.1242 171.09 46.0755 171.147 46.0267C171.27 45.9374 171.393 45.8399 171.508 45.7425C171.574 45.6856 171.631 45.6288 171.688 45.5638C171.778 45.4744 171.877 45.3932 171.959 45.3039C172.016 45.2389 172.065 45.1658 172.123 45.1008C172.188 45.0196 172.27 44.9303 172.328 44.8491C172.328 44.8491 172.328 44.8491 172.336 44.8409C172.385 44.776 172.418 44.7029 172.467 44.6298C172.516 44.5486 172.582 44.4592 172.623 44.378C172.664 44.3049 172.688 44.2318 172.721 44.1587C172.762 44.0694 172.803 43.9881 172.836 43.8988V43.8907C172.861 43.8176 172.869 43.7445 172.893 43.6795C172.918 43.5902 172.943 43.5008 172.959 43.4196C172.975 43.3465 172.975 43.2653 172.975 43.1922C172.984 43.1029 173 43.0135 173 42.9242C173 42.916 173 42.9161 173 42.9079L173.008 45.3201C173.008 46.6359 172.131 47.9516 170.377 48.9587L129.477 72.358L129.469 69.9458L170.36 46.5547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.975 43.1922C172.967 43.2653 172.967 43.3465 172.959 43.4196C172.943 43.5089 172.918 43.5983 172.893 43.6795C172.877 43.7526 172.861 43.8257 172.836 43.9069C172.803 43.9962 172.762 44.0774 172.721 44.1668C172.689 44.2399 172.664 44.313 172.623 44.3861C172.582 44.4754 172.516 44.5566 172.467 44.6379C172.426 44.711 172.385 44.784 172.336 44.849C172.279 44.9384 172.197 45.0196 172.131 45.1008C172.074 45.1658 172.025 45.2389 171.967 45.3039C171.885 45.3932 171.787 45.4744 171.697 45.5638C171.631 45.6206 171.582 45.6856 171.516 45.7424C171.401 45.8399 171.278 45.9292 171.156 46.0267C171.098 46.0673 171.041 46.116 170.983 46.1648C170.795 46.3028 170.59 46.4328 170.369 46.5546L129.469 69.9457L125.567 67.6959L168.04 43.4033L103.31 6.14814L60.8447 30.4408L57.0819 28.2722L97.9812 4.873C101.473 2.87501 107.114 2.87501 110.581 4.873L170.41 39.318C172.139 40.317 173 41.6165 173 42.9241C172.992 43.0135 172.984 43.1028 172.975 43.1922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.779 71.5785L122.69 73.8283V76.2323V73.8283L118.779 71.5785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.559 67.7043L129.461 69.9459L122.69 73.8282L118.779 71.5784L125.559 67.7043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.3728 52.9712L54.0649 34.3152L60.8446 30.4411L103.31 6.14844L168.032 43.4036L125.559 67.7044L118.779 71.5785L86.3728 52.9712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.3728 52.9711L54.0649 34.4369V34.3151L86.3728 52.9711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.461 69.9459L129.469 72.3581L122.69 76.2322V73.8281L129.461 69.9459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.91 77.7023L113.819 78.8963L115.91 77.7023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.2935 38.1891L43.5306 36.0287L50.3021 32.1545L53.9584 34.3718L47.2935 38.1891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.008 75.4526L118.681 71.6353L53.9585 34.372L54.0651 34.437L86.3729 52.9712L118.779 71.5785L122.69 73.8282L115.91 77.7024L112.008 75.4526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.69 73.8282V76.2323L115.918 80.1065L115.91 77.7024L122.69 73.8282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.681 71.6353L112.007 75.4526L69.321 99.8671L4.60693 62.6038L47.2933 38.1893L53.9582 34.372L118.681 71.6353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.0245937 63.3182C0.0327915 63.4075 0.0409894 63.4969 0.0573852 63.5862V63.5943C0.073781 63.6593 0.0901767 63.7243 0.106573 63.7974C0.131166 63.8948 0.15576 63.9842 0.188551 64.0817V64.0898C0.213145 64.1629 0.245937 64.2278 0.278728 64.2928C0.319718 64.3822 0.360707 64.4796 0.409894 64.569V64.5771C0.442686 64.6339 0.483675 64.6989 0.516467 64.7558C0.58205 64.8614 0.655831 64.9751 0.73781 65.0806C0.73781 65.0806 0.73781 65.0806 0.73781 65.0888C0.73781 65.0969 0.746008 65.0969 0.746008 65.105C0.85258 65.2431 0.959153 65.373 1.09032 65.5111C1.09852 65.5192 1.10671 65.5274 1.11491 65.5355C1.23788 65.6654 1.36905 65.7873 1.51661 65.9172C1.5576 65.9497 1.60679 65.9822 1.64778 66.0147C1.76255 66.1121 1.88551 66.2096 2.01668 66.2989C2.09866 66.3558 2.19703 66.4126 2.28721 66.4695C2.38558 66.5345 2.48396 66.5994 2.59053 66.6644C2.59053 66.6644 2.59873 66.6644 2.59873 66.6725L62.4269 101.118C63.1729 101.548 64.0255 101.881 64.9355 102.125C64.9764 102.133 65.0256 102.149 65.0666 102.157C65.3044 102.214 65.5421 102.271 65.7798 102.32C65.8126 102.328 65.8536 102.336 65.8864 102.344C66.2963 102.425 66.7062 102.482 67.1243 102.531C67.2309 102.539 67.3374 102.547 67.444 102.555C67.6408 102.571 67.8457 102.588 68.0425 102.596C68.1736 102.604 68.2966 102.604 68.4278 102.604C68.5917 102.604 68.7557 102.612 68.9114 102.604C68.936 102.604 68.9606 102.604 68.977 102.604C69.2393 102.596 69.5017 102.588 69.764 102.571C69.8378 102.563 69.9116 102.563 69.9854 102.555C70.551 102.506 71.1167 102.425 71.6659 102.32C71.7315 102.303 71.7971 102.295 71.8627 102.279C72.0512 102.238 72.2316 102.19 72.4119 102.141C72.4529 102.133 72.5021 102.117 72.5431 102.108C72.9284 102.003 73.3137 101.881 73.6744 101.743C73.7154 101.727 73.7564 101.71 73.7974 101.694C73.9859 101.621 74.1745 101.54 74.3548 101.459C74.5762 101.353 74.7975 101.239 75.0107 101.118L113.811 78.9204L115.91 77.7183L115.918 80.1305L75.0189 103.53C74.8057 103.652 74.5926 103.765 74.363 103.871C74.2892 103.903 74.2073 103.936 74.1335 103.968C74.0023 104.025 73.8712 104.09 73.7318 104.139C73.7154 104.147 73.699 104.147 73.6826 104.155C73.3711 104.277 73.0514 104.383 72.7234 104.472C72.6989 104.48 72.6743 104.488 72.6497 104.496C72.5759 104.521 72.4939 104.529 72.4201 104.553C72.2398 104.602 72.0512 104.651 71.8709 104.691C71.8217 104.699 71.7725 104.716 71.7233 104.724C71.6495 104.74 71.5757 104.748 71.502 104.764C71.3462 104.797 71.1904 104.821 71.0265 104.845C70.9609 104.854 70.9035 104.87 70.8379 104.878C70.7724 104.886 70.6986 104.894 70.633 104.902C70.4854 104.919 70.3379 104.935 70.1903 104.951C70.1165 104.959 70.0509 104.967 69.9772 104.975C69.9116 104.984 69.846 104.984 69.7804 104.984C69.6329 104.992 69.4771 105 69.3295 105.008C69.2557 105.008 69.182 105.016 69.1 105.016C69.0426 105.016 68.977 105.016 68.9196 105.016C68.7557 105.016 68.5917 105.016 68.436 105.016C68.354 105.016 68.272 105.016 68.19 105.016C68.1408 105.016 68.0916 105.008 68.0507 105.008C67.8457 105 67.649 104.984 67.4522 104.967C67.3702 104.959 67.2883 104.959 67.2063 104.951C67.1817 104.951 67.1571 104.943 67.1325 104.943C66.7882 104.91 66.4521 104.862 66.116 104.805C66.0996 104.805 66.0832 104.805 66.0668 104.797C65.9684 104.781 65.8782 104.756 65.7798 104.74C65.6159 104.707 65.4519 104.675 65.288 104.634C65.1732 104.61 65.0584 104.569 64.9355 104.545C64.7797 104.504 64.6239 104.464 64.4764 104.415C64.4436 104.407 64.4108 104.399 64.378 104.391C64.3206 104.374 64.2714 104.35 64.2222 104.334C63.9845 104.253 63.7468 104.163 63.5172 104.074C63.4352 104.041 63.3451 104.001 63.2631 103.968C62.9762 103.838 62.6892 103.7 62.4187 103.546L2.59873 69.0604C2.55774 69.036 2.52495 69.0116 2.48396 68.9873C2.41838 68.9467 2.36099 68.9142 2.30361 68.8736C2.18884 68.8005 2.08226 68.7274 1.97569 68.6543C1.87732 68.5812 1.77894 68.5081 1.68876 68.435C1.63138 68.3863 1.5658 68.3375 1.50841 68.2888C1.45103 68.2401 1.40184 68.1913 1.35265 68.1426C1.1477 67.9558 0.959153 67.7609 0.803393 67.5578V67.5741C0.778799 67.5416 0.762403 67.5172 0.746008 67.4847C0.672227 67.3791 0.598446 67.2817 0.532863 67.1761C0.508269 67.1355 0.46728 67.0868 0.442686 67.0461C0.42629 67.0218 0.42629 67.0055 0.409894 66.9812C0.360707 66.8918 0.319718 66.7944 0.278728 66.705C0.254134 66.6482 0.221343 66.5994 0.204947 66.5426C0.196749 66.5263 0.196749 66.5101 0.188551 66.4857C0.15576 66.3964 0.139364 66.3071 0.11477 66.2258C0.0983746 66.169 0.073781 66.104 0.0655831 66.0472C0.0655831 66.0309 0.0655831 66.0147 0.0573852 65.9984C0.0409894 65.9091 0.0327915 65.8116 0.0245937 65.7223C0.0163958 65.6654 0.00819789 65.6004 0 65.5436C0 65.5192 0 65.4949 0 65.4624L0 63.0583C0 63.1476 0.0163958 63.2288 0.0245937 63.3182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M4.60717 62.6039L69.3295 99.8672L112.016 75.4528L115.918 77.7025L113.819 78.9046L75.0106 101.094C74.7975 101.215 74.5843 101.329 74.3548 101.435C74.1744 101.516 73.9859 101.597 73.7973 101.67C73.7563 101.687 73.7154 101.703 73.6744 101.719C73.3137 101.857 72.9284 101.979 72.5431 102.085C72.5021 102.093 72.4529 102.109 72.4119 102.117C72.2315 102.166 72.043 102.214 71.8626 102.255C71.7971 102.271 71.7315 102.279 71.6659 102.296C71.1166 102.409 70.5592 102.482 69.9853 102.531C69.9115 102.539 69.8378 102.547 69.764 102.547C69.5016 102.564 69.2393 102.58 68.977 102.58C68.9524 102.58 68.9278 102.58 68.9114 102.58C68.7474 102.58 68.5835 102.58 68.4277 102.58C68.2966 102.58 68.1736 102.572 68.0424 102.572C67.8375 102.564 67.6407 102.547 67.444 102.531C67.3374 102.523 67.2308 102.515 67.1243 102.507C66.7062 102.466 66.2881 102.401 65.8864 102.32C65.8536 102.312 65.8126 102.304 65.7798 102.296C65.5421 102.247 65.3043 102.19 65.0666 102.133C65.0256 102.125 64.9764 102.109 64.9354 102.101C64.0255 101.857 63.1729 101.524 62.4269 101.094L2.59049 66.6486C2.59049 66.6486 2.5823 66.6486 2.5823 66.6405C2.45933 66.5755 2.35276 66.5024 2.24618 66.4293C2.1642 66.3806 2.08223 66.3319 2.00844 66.275C1.87728 66.1857 1.76251 66.0882 1.63954 65.9908C1.59855 65.9583 1.54936 65.9258 1.50837 65.8933C1.36081 65.7715 1.22965 65.6415 1.10668 65.5116C1.09848 65.5034 1.09028 65.4953 1.08208 65.4872C0.959115 65.3572 0.844344 65.2192 0.737772 65.0811C0.729574 65.073 0.729574 65.073 0.721376 65.0649C0.639397 64.9593 0.573814 64.8537 0.500033 64.74C0.459044 64.675 0.426252 64.6182 0.385263 64.5532C0.336076 64.4638 0.295086 64.3664 0.254097 64.277C0.221305 64.2039 0.188514 64.1308 0.16392 64.0659C0.131128 63.9765 0.106535 63.8791 0.081941 63.7816C0.0655452 63.7085 0.0409516 63.6435 0.0327537 63.5704C0.0163579 63.4811 0.00816002 63.3918 -3.7862e-05 63.3024C-0.131204 61.8973 0.737772 60.476 2.60689 59.4039L43.5307 36.0291L47.2936 38.1976L4.60717 62.6039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.681 72.2279L56.1228 32.2763L104.056 1.62421L165.794 38.79L116.681 72.2279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.89453 53.8969L47.2934 36.313L116.213 72.7803L70.6328 98.9085L8.89453 64.2361V53.8969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.853 66.9325L117.107 67.2736L109.237 70.8797L70.6328 88.5692L8.89453 53.8968L19.1829 49.1861L54.1059 33.1941L56.1144 32.2763L117.853 66.9325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.107 67.2739L109.237 70.88C93.8986 71.0018 71.9201 79.343 71.9201 79.343L19.1831 49.1864L54.1061 33.1943C54.2864 33.2431 54.475 33.2918 54.6554 33.3487L117.107 67.2739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.85352 36.6381L69.5918 71.2862C69.5918 71.2862 86.0122 57.7876 117.853 66.9247L56.1145 32.2767C24.3067 23.1395 7.85352 36.6381 7.85352 36.6381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.633 98.9087V88.5695C70.633 88.5695 95.5956 70.685 111.942 67.3957C115 66.7784 117.869 69.0525 117.869 72.1389V71.7815L70.633 98.9087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.869 71.7815V72.0495C117.869 68.1753 119.402 64.4799 122.091 61.6697C136.855 46.2218 165.802 38.7903 165.802 38.7903V44.3619L117.869 71.7815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.056 1.62421L165.794 38.7901C165.794 38.7901 122.632 42.8266 117.869 66.9243L56.131 32.2763C60.9022 8.17046 104.056 1.62421 104.056 1.62421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.255 19.2569C113.385 20.4183 92.8083 29.2956 86.332 41.3079L87.3239 41.9008C93.8166 29.8966 113.713 21.2711 125.239 19.866L124.255 19.2569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.05 16.78C109.294 17.6978 88.3238 26.7375 81.8639 38.7579L82.864 39.3508C89.3322 27.3385 109.548 18.575 121.033 17.381L120.05 16.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.852 14.3027C105.203 14.9769 83.8397 24.179 77.4125 36.2156L78.4209 36.8085C84.8644 24.78 105.4 15.8865 116.853 14.9119L115.852 14.3027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.655 11.8256C101.113 12.2641 79.3556 21.6287 72.953 33.6735L73.9777 34.2664C80.3885 22.2297 101.244 13.19 112.664 12.4347L111.655 11.8256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.458 9.34827C97.0302 9.54319 74.8714 19.0702 68.4934 31.1312L69.5263 31.7241C75.9125 19.6793 97.0876 10.5016 108.466 9.96553L107.458 9.34827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.277 7.48866L103.252 6.8714C92.9395 6.82267 70.3872 16.5121 64.042 28.5894L65.0831 29.1823C71.4447 17.1294 92.9395 7.81354 104.277 7.48866Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.0648 32.6909V32.8127L53.9583 32.7477L50.302 30.5305L54.0648 32.6909Z",
    fill: "#C4A469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0649 32.6909L60.8446 28.8168L54.0649 32.6909Z",
    fill: "#887249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8445 28.8166L54.0648 32.6908L50.302 30.5303L57.0817 26.6481L60.8445 28.8166Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36078 66.5264V66.5426C1.15583 66.3558 0.967283 66.1528 0.811523 65.9578V65.9416C0.967283 66.1446 1.15583 66.3396 1.36078 66.5264Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51648 66.6728C1.46729 66.6322 1.40991 66.5916 1.36072 66.5428V66.5266C1.40991 66.5753 1.45909 66.624 1.51648 66.6728Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51648 64.2684C1.55747 64.3009 1.60666 64.3334 1.64765 64.3658C1.59846 64.3334 1.54927 64.3009 1.51648 64.2684Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48406 67.371C2.41848 67.3304 2.36929 67.2898 2.30371 67.2491C2.36929 67.2898 2.42668 67.3304 2.48406 67.371Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68884 66.8105C1.77902 66.8836 1.87739 66.9567 1.97577 67.0298C1.87739 66.9648 1.78722 66.8917 1.68884 66.8105Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27871 64.8294C2.18853 64.7725 2.09016 64.7157 2.00818 64.6588C2.08196 64.7075 2.16394 64.7563 2.24592 64.8131C2.25412 64.8131 2.27051 64.8213 2.27871 64.8294Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59853 67.4361C2.55755 67.4117 2.52475 67.3955 2.48376 67.3711V67.363C2.52475 67.3873 2.55755 67.4117 2.59853 67.4361Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36 44.9305C170.582 44.8086 170.787 44.6787 170.975 44.5406C171.041 44.5 171.09 44.4513 171.147 44.4025C171.27 44.3132 171.393 44.2157 171.508 44.1183C171.574 44.0614 171.631 44.0046 171.688 43.9396C171.778 43.8502 171.877 43.769 171.959 43.6797C172.016 43.6147 172.065 43.5416 172.123 43.4766C172.188 43.3954 172.27 43.3061 172.328 43.2249C172.328 43.2249 172.328 43.2249 172.336 43.2167C172.385 43.1518 172.418 43.0787 172.467 43.0056C172.516 42.9243 172.582 42.835 172.623 42.7538C172.664 42.6807 172.688 42.6076 172.721 42.5345C172.762 42.4452 172.803 42.3639 172.836 42.2746V42.2665C172.861 42.1934 172.869 42.1203 172.893 42.0553C172.918 41.966 172.943 41.8766 172.959 41.7954C172.975 41.7223 172.975 41.6411 172.975 41.568C172.984 41.4786 173 41.3893 173 41.3C173 41.2918 173 41.2918 173 41.2837L173.008 43.6959C173.008 45.0117 172.131 46.3274 170.377 47.3345L129.477 70.7338L129.469 68.3216L170.36 44.9305Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.975 41.5681C172.967 41.6412 172.967 41.7224 172.959 41.7955C172.943 41.8848 172.918 41.9742 172.893 42.0554C172.877 42.1285 172.861 42.2016 172.836 42.2828C172.803 42.3721 172.762 42.4534 172.721 42.5427C172.689 42.6158 172.664 42.6889 172.623 42.762C172.582 42.8513 172.516 42.9326 172.467 43.0138C172.426 43.0869 172.385 43.16 172.336 43.2249C172.279 43.3143 172.197 43.3955 172.131 43.4767C172.074 43.5417 172.025 43.6148 171.967 43.6798C171.885 43.7691 171.787 43.8503 171.697 43.9397C171.631 43.9965 171.582 44.0615 171.516 44.1184C171.401 44.2158 171.278 44.3052 171.156 44.4026C171.098 44.4432 171.041 44.492 170.983 44.5407C170.795 44.6788 170.59 44.8087 170.369 44.9305L129.469 68.3216L125.567 66.0719L168.04 41.7792L103.31 4.52406L60.8447 28.8167L57.0819 26.6481L97.9812 3.24892C101.473 1.25093 107.114 1.25093 110.581 3.24892L170.41 37.6939C172.139 38.6929 173 39.9924 173 41.3C172.992 41.3894 172.984 41.4787 172.975 41.5681Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.779 69.9538L122.69 72.2036V74.6077V72.2036L118.779 69.9538Z",
    fill: "#C4A469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.559 66.0802L129.461 68.3218L122.69 72.2041L118.779 69.9543L125.559 66.0802Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3728 51.3466L54.0649 32.6906L60.8446 28.8164L103.31 4.5238L168.032 41.779L125.559 66.0797L118.779 69.9539L86.3728 51.3466Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3728 51.3469L54.0649 32.8127V32.6909L86.3728 51.3469Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.461 68.3217L129.469 70.7339L122.69 74.608V72.2039L129.461 68.3217Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91 76.0777L113.819 77.2716L115.91 76.0777Z",
    fill: "#C4A469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2935 36.565L43.5306 34.4046L50.3021 30.5305L53.9584 32.7477L47.2935 36.565Z",
    fill: "#DBB775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.008 73.8284L118.681 70.0111L53.9585 32.7478L54.0651 32.8128L86.3729 51.347L118.779 69.9543L122.69 72.204L115.91 76.0782L112.008 73.8284Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.69 72.2036V74.6077L115.918 78.4818L115.91 76.0778L122.69 72.2036Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.681 70.0111L112.007 73.8284L69.321 98.2429L4.60693 60.9796L47.2933 36.5651L53.9582 32.7478L118.681 70.0111Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0245937 61.694C0.0327915 61.7833 0.0409894 61.8726 0.0573852 61.962V61.9701C0.073781 62.0351 0.0901767 62.1001 0.106573 62.1731C0.131166 62.2706 0.15576 62.36 0.188551 62.4574V62.4655C0.213145 62.5386 0.245937 62.6036 0.278728 62.6686C0.319718 62.7579 0.360707 62.8554 0.409894 62.9447V62.9529C0.442686 63.0097 0.483675 63.0747 0.516467 63.1315C0.58205 63.2371 0.655831 63.3508 0.73781 63.4564C0.73781 63.4564 0.73781 63.4564 0.73781 63.4645C0.73781 63.4727 0.746008 63.4727 0.746008 63.4808C0.85258 63.6188 0.959153 63.7488 1.09032 63.8869C1.09852 63.895 1.10671 63.9031 1.11491 63.9112C1.23788 64.0412 1.36905 64.163 1.51661 64.293C1.5576 64.3255 1.60679 64.3579 1.64778 64.3904C1.76255 64.4879 1.88551 64.5854 2.01668 64.6747C2.09866 64.7315 2.19703 64.7884 2.28721 64.8453C2.38558 64.9102 2.48396 64.9752 2.59053 65.0402C2.59053 65.0402 2.59873 65.0402 2.59873 65.0483L62.4269 99.4933C63.1729 99.9238 64.0255 100.257 64.9355 100.5C64.9764 100.509 65.0256 100.525 65.0666 100.533C65.3044 100.59 65.5421 100.647 65.7798 100.695C65.8126 100.703 65.8536 100.712 65.8864 100.72C66.2963 100.801 66.7062 100.858 67.1243 100.907C67.2309 100.915 67.3374 100.923 67.444 100.931C67.6408 100.947 67.8457 100.963 68.0425 100.972C68.1736 100.98 68.2966 100.98 68.4278 100.98C68.5917 100.98 68.7557 100.988 68.9114 100.98C68.936 100.98 68.9606 100.98 68.977 100.98C69.2393 100.972 69.5017 100.963 69.764 100.947C69.8378 100.939 69.9116 100.939 69.9854 100.931C70.551 100.882 71.1167 100.801 71.6659 100.695C71.7315 100.679 71.7971 100.671 71.8627 100.655C72.0512 100.614 72.2316 100.565 72.4119 100.517C72.4529 100.509 72.5021 100.492 72.5431 100.484C72.9284 100.379 73.3137 100.257 73.6744 100.119C73.7154 100.102 73.7564 100.086 73.7974 100.07C73.9859 99.9969 74.1745 99.9157 74.3548 99.8344C74.5762 99.7289 74.7975 99.6152 75.0107 99.4933L113.811 77.2961L115.91 76.0941L115.918 78.5063L75.0189 101.906C74.8057 102.027 74.5926 102.141 74.363 102.247C74.2892 102.279 74.2073 102.312 74.1335 102.344C74.0023 102.401 73.8712 102.466 73.7318 102.515C73.7154 102.523 73.699 102.523 73.6826 102.531C73.3711 102.653 73.0514 102.758 72.7234 102.848C72.6989 102.856 72.6743 102.864 72.6497 102.872C72.5759 102.896 72.4939 102.905 72.4201 102.929C72.2398 102.978 72.0512 103.026 71.8709 103.067C71.8217 103.075 71.7725 103.091 71.7233 103.099C71.6495 103.116 71.5757 103.124 71.502 103.14C71.3462 103.173 71.1904 103.197 71.0265 103.221C70.9609 103.229 70.9035 103.246 70.8379 103.254C70.7724 103.262 70.6986 103.27 70.633 103.278C70.4854 103.294 70.3379 103.311 70.1903 103.327C70.1165 103.335 70.0509 103.343 69.9772 103.351C69.9116 103.359 69.846 103.359 69.7804 103.359C69.6329 103.367 69.4771 103.376 69.3295 103.384C69.2557 103.384 69.182 103.392 69.1 103.392C69.0426 103.392 68.977 103.392 68.9196 103.392C68.7557 103.392 68.5917 103.392 68.436 103.392C68.354 103.392 68.272 103.392 68.19 103.392C68.1408 103.392 68.0916 103.384 68.0507 103.384C67.8457 103.376 67.649 103.359 67.4522 103.343C67.3702 103.335 67.2883 103.335 67.2063 103.327C67.1817 103.327 67.1571 103.319 67.1325 103.319C66.7882 103.286 66.4521 103.238 66.116 103.181C66.0996 103.181 66.0832 103.181 66.0668 103.173C65.9684 103.156 65.8782 103.132 65.7798 103.116C65.6159 103.083 65.4519 103.051 65.288 103.01C65.1732 102.986 65.0584 102.945 64.9355 102.921C64.7797 102.88 64.6239 102.84 64.4764 102.791C64.4436 102.783 64.4108 102.775 64.378 102.766C64.3206 102.75 64.2714 102.726 64.2222 102.71C63.9845 102.628 63.7468 102.539 63.5172 102.45C63.4352 102.417 63.3451 102.377 63.2631 102.344C62.9762 102.214 62.6892 102.076 62.4187 101.922L2.59873 67.4361C2.55774 67.4118 2.52495 67.3874 2.48396 67.363C2.41838 67.3224 2.36099 67.29 2.30361 67.2493C2.18884 67.1762 2.08226 67.1031 1.97569 67.03C1.87732 66.9569 1.77894 66.8839 1.68876 66.8108C1.63138 66.762 1.5658 66.7133 1.50841 66.6646C1.45103 66.6158 1.40184 66.5671 1.35265 66.5184C1.1477 66.3316 0.959153 66.1366 0.803393 65.9336V65.9498C0.778799 65.9173 0.762403 65.893 0.746008 65.8605C0.672227 65.7549 0.598446 65.6574 0.532863 65.5519C0.508269 65.5113 0.46728 65.4625 0.442686 65.4219C0.42629 65.3975 0.42629 65.3813 0.409894 65.3569C0.360707 65.2676 0.319718 65.1701 0.278728 65.0808C0.254134 65.0239 0.221343 64.9752 0.204947 64.9184C0.196749 64.9021 0.196749 64.8859 0.188551 64.8615C0.15576 64.7722 0.139364 64.6828 0.11477 64.6016C0.0983746 64.5447 0.073781 64.4798 0.0655831 64.4229C0.0655831 64.4067 0.0655831 64.3904 0.0573852 64.3742C0.0409894 64.2848 0.0327915 64.1874 0.0245937 64.098C0.0163958 64.0412 0.00819789 63.9762 0 63.9194C0 63.895 0 63.8706 0 63.8381L0 61.4341C0 61.5234 0.0163958 61.6046 0.0245937 61.694Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60717 60.9793L69.3295 98.2426L112.016 73.8282L115.918 76.0779L113.819 77.28L75.0106 99.469C74.7975 99.5908 74.5843 99.7046 74.3548 99.8101C74.1744 99.8914 73.9859 99.9726 73.7973 100.046C73.7563 100.062 73.7154 100.078 73.6744 100.094C73.3137 100.232 72.9284 100.354 72.5431 100.46C72.5021 100.468 72.4529 100.484 72.4119 100.492C72.2315 100.541 72.043 100.59 71.8626 100.63C71.7971 100.647 71.7315 100.655 71.6659 100.671C71.1166 100.785 70.5592 100.858 69.9853 100.907C69.9115 100.915 69.8378 100.923 69.764 100.923C69.5016 100.939 69.2393 100.955 68.977 100.955C68.9524 100.955 68.9278 100.955 68.9114 100.955C68.7474 100.955 68.5835 100.955 68.4277 100.955C68.2966 100.955 68.1736 100.947 68.0424 100.947C67.8375 100.939 67.6407 100.923 67.444 100.907C67.3374 100.898 67.2308 100.89 67.1243 100.882C66.7062 100.842 66.2881 100.777 65.8864 100.695C65.8536 100.687 65.8126 100.679 65.7798 100.671C65.5421 100.622 65.3043 100.565 65.0666 100.509C65.0256 100.5 64.9764 100.484 64.9354 100.476C64.0255 100.232 63.1729 99.8995 62.4269 99.469L2.59049 65.024C2.59049 65.024 2.5823 65.024 2.5823 65.0159C2.45933 64.9509 2.35276 64.8778 2.24618 64.8047C2.1642 64.756 2.08223 64.7073 2.00844 64.6504C1.87728 64.5611 1.76251 64.4636 1.63954 64.3661C1.59855 64.3336 1.54936 64.3012 1.50837 64.2687C1.36081 64.1468 1.22965 64.0169 1.10668 63.8869C1.09848 63.8788 1.09028 63.8707 1.08208 63.8626C0.959115 63.7326 0.844344 63.5946 0.737772 63.4565C0.729574 63.4484 0.729574 63.4484 0.721376 63.4402C0.639397 63.3347 0.573814 63.2291 0.500033 63.1154C0.459044 63.0504 0.426252 62.9935 0.385263 62.9286C0.336076 62.8392 0.295086 62.7418 0.254097 62.6524C0.221305 62.5793 0.188514 62.5062 0.16392 62.4412C0.131128 62.3519 0.106535 62.2544 0.081941 62.157C0.0655452 62.0839 0.0409516 62.0189 0.0327537 61.9458C0.0163579 61.8565 0.00816002 61.7671 -3.7862e-05 61.6778C-0.131204 60.2727 0.737772 58.8514 2.60689 57.7793L43.5307 34.4044L47.2936 36.573L4.60717 60.9793Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.681 70.6037L56.1228 30.6521L104.056 0L165.794 37.1658L116.681 70.6037Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89465 52.2723L47.2935 34.6884L116.213 71.1557L70.6329 97.2839L8.89465 62.6115V52.2723Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.853 65.3083L117.107 65.6494L109.237 69.2555L70.6329 86.945L8.89465 52.2726L19.183 47.5619L54.106 31.5699L56.1145 30.6521L117.853 65.3083Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.107 65.6491L109.237 69.2552C93.8986 69.3771 71.9201 77.7183 71.9201 77.7183L19.1831 47.5616L54.1061 31.5696C54.2864 31.6183 54.475 31.667 54.6554 31.7239L117.107 65.6491Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85352 35.0135L69.5918 69.6616C69.5918 69.6616 86.0122 56.1629 117.853 65.3001L56.1145 30.652C24.3067 21.5149 7.85352 35.0135 7.85352 35.0135Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6329 97.284V86.9448C70.6329 86.9448 95.5955 69.0604 111.942 65.771C115 65.1537 117.869 67.4279 117.869 70.5142V70.1568L70.6329 97.284Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.869 70.1568V70.4249C117.869 66.5507 119.402 62.8552 122.091 60.0451C136.855 44.5972 165.802 37.1656 165.802 37.1656V42.7373L117.869 70.1568Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.056 0L165.794 37.1658C165.794 37.1658 122.632 41.2024 117.869 65.3001L56.131 30.6521C60.9022 6.54626 104.056 0 104.056 0Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M124.255 17.6327C113.385 18.7941 92.8079 27.6714 86.3316 39.6837L87.3235 40.2766C93.8163 28.2724 113.713 19.6469 125.239 18.2418L124.255 17.6327Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M120.05 15.1554C109.294 16.0732 88.3238 25.1129 81.8639 37.1333L82.864 37.7262C89.3322 25.7139 109.548 16.9503 121.033 15.7564L120.05 15.1554Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M115.852 12.6781C105.203 13.3522 83.8397 22.5543 77.4125 34.591L78.4209 35.1839C84.8644 23.1554 105.4 14.2619 116.853 13.2872L115.852 12.6781Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M111.655 10.2013C101.112 10.6399 79.3551 20.0044 72.9525 32.0492L73.9773 32.6421C80.388 20.6055 101.243 11.5658 112.663 10.8104L111.655 10.2013Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M107.458 7.72363C97.0299 7.91856 74.871 17.4456 68.493 29.5066L69.526 30.0995C75.9121 18.0547 97.0873 8.87694 108.466 8.3409L107.458 7.72363Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M104.277 5.86403L103.252 5.24677C92.9392 5.19803 70.3868 14.8875 64.0416 26.9647L65.0828 27.5576C71.4443 15.5047 92.9392 6.18891 104.277 5.86403Z",
    fill: "#CCCCCC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.302,
    y1: 28.0508,
    x2: 61.1329,
    y2: 28.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.791756,
    y1: 65.9277,
    x2: 1.44164,
    y2: 66.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1.35511,
    y1: 66.5232,
    x2: 1.52245,
    y2: 66.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1.51176,
    y1: 64.2661,
    x2: 1.62846,
    y2: 64.3739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2.29722,
    y1: 67.2463,
    x2: 2.44357,
    y2: 67.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.67852,
    y1: 66.8054,
    x2: 1.94047,
    y2: 67.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1.99844,
    y1: 64.6549,
    x2: 2.20265,
    y2: 64.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2.47963,
    y1: 67.3613,
    x2: 2.56721,
    y2: 67.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 127.902,
    y1: 40.6024,
    x2: 163.283,
    y2: 76.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 52.91,
    y1: 0.21022,
    x2: 131.653,
    y2: 94.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 118.779,
    y1: 67.5018,
    x2: 129.753,
    y2: 68.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 122.69,
    y1: 69.781,
    x2: 129.672,
    y2: 70.0587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 53.9585,
    y1: 42.8066,
    x2: 124.62,
    y2: 46.9394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 115.91,
    y1: 73.6611,
    x2: 122.893,
    y2: 73.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -4.17186,
    y1: 60.4633,
    x2: 37.4496,
    y2: 139.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -4.18526,
    y1: 32.8647,
    x2: 74.5283,
    y2: 126.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 123.147,
    y1: 25.8844,
    x2: 151.127,
    y2: 6.69094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 22.0154,
    y1: 65.9862,
    x2: 129.329,
    y2: 65.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#B1ADE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1745,
    stopColor: "#BFBCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    stopColor: "#DBDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    stopColor: "#ECECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 8.89629,
    y1: 58.7955,
    x2: 117.854,
    y2: 58.7955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 19.1847,
    y1: 54.6408,
    x2: 117.108,
    y2: 54.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 108.37,
    y1: 35.7738,
    x2: 61.4402,
    y2: 49.8192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 96.7608,
    y1: 85.3536,
    x2: 44.7776,
    y2: 33.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#B1ADE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1745,
    stopColor: "#BFBCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    stopColor: "#DBDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    stopColor: "#ECECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 134.985,
    y1: 47.0849,
    x2: 83.0017,
    y2: -4.83789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#B1ADE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1745,
    stopColor: "#BFBCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    stopColor: "#DBDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    stopColor: "#ECECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 56.1309,
    y1: 32.6524,
    x2: 165.794,
    y2: 32.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5784,
    stopColor: "#ECECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5173Caa5);
export default __webpack_public_path__ + "static/media/feature-5.173caa5.173caa5b2436b7c0058f2fe9f471d4bb.svg";
export { ForwardRef as ReactComponent };